module.exports = __webpack_public_path__ + "static/feature_messages-cdec089c4e17453139b68f73fc9b14d7.png";